import { type } from '../constants/C2CModalConstant'
import { C2CModalInterface, C2CCallInterface, GlobalC2COption } from '../models/C2CModal.interface';

const initialState: C2CModalInterface = {
    modalSource: '',
    showModal: false,
    initialSchema: null,
    passedProps: null
}

export const C2CModalReducer = (state: C2CModalInterface = initialState, action: any): C2CModalInterface => {
    switch (action.type) {
        case type.SHOW_C2C_MODAL:
            return {
                ...state,
                showModal: true,
                modalSource: action.payload.modalSource,
                initialSchema: action.payload.initialSchema,
                passedProps: action.payload.passedProps || null,
            }

        case type.HIDE_C2C_MODAL:
            return {
                ...state,
                showModal: false,
                modalSource: '',
                initialSchema: null,
                passedProps: null,
            }
        default:
            return state;
    }
}

const initialCallState = {
    callInitiated: false,
    callSuccess: false,
    callError: false,
    callErrorMsg: ''
}

export const C2CCallReducer = (state: C2CCallInterface = initialCallState, action: any): C2CCallInterface => {
    switch (action.type) {
        case type.C2C_CALL_INITIATED:
            return {
                ...state,
                callInitiated: true,
            }
        case type.C2C_CALL_SUCCESS:
            return {
                ...state,
                callInitiated: false,
                callSuccess: true,
            }
        case type.C2C_CALL_FAILED:
            return {
                ...state,
                callInitiated: false,
                callError: true,
                callErrorMsg: action.payload.error
            }
        default:
            return state;
    }
}

const globalC2COption = {
    data: "0"
}

export const C2CGlobalOptionReducer = (state: GlobalC2COption = globalC2COption, action: any): GlobalC2COption => {
    switch (action.type) {
        case type.C2C_GLOBAL_OPTION_SUCCESS:
            return {
                data: action.payload.res,
            }
        default:
            return state;
    }
}


